<div class="container-fluid px-2 px-sm-4 py-3" style="padding-bottom:calc(48px + env(safe-area-inset-bottom, 0px) + 16px);">

  <h1 class="text-center fw-bold mb-3">{{ title }}</h1>

  <!-- Mobile tab navigation -->
  <nav class="d-md-none mb-3">
    <div class="d-flex nav-pills-mobile" style="background:var(--bs-tertiary-bg);border-radius:10px;padding:3px;gap:3px;">
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='energie'"
              (click)="activeTab='energie'">⚡ Energie</button>
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='klima'"
              (click)="activeTab='klima'">🌡 Klima</button>
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='muell'"
              (click)="activeTab='muell'">🗑️ Müll</button>
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='statistik'"
              (click)="activeTab='statistik'">📊 Statistik</button>
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='netzwerk'"
              (click)="activeTab='netzwerk'">🌐 Netz</button>
    </div>
  </nav>

  <!-- ═══ ENERGIE ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'energie'">

    <div class="section-divider d-none d-md-flex align-items-center gap-3 mb-2">
      <div class="flex-grow-1 border-top"></div>
      <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">⚡ Energie</span>
      <div class="flex-grow-1 border-top"></div>
    </div>

    <!-- Live Solar Cards -->
    <div class="section-label d-flex align-items-center gap-2 mb-2">
      <span class="badge bg-danger" style="font-size:.7rem;letter-spacing:.05em;"><span [style.opacity]="liveDotOn ? '1' : '0'">●</span> LIVE</span>
      <span class="fw-semibold small text-uppercase tracking-wide">{{ 'AKTUELL' | translate }}</span>
      <span *ngIf="solarUpdatedAt" class="text-muted" style="font-size:.65rem;">· {{ 'UPDATED_AGO' | translate:{time: updatedAgo(solarUpdatedAt)} }}</span>
      <button *ngIf="solarHistory.length" class="btn btn-sm btn-outline-secondary ms-auto" style="font-size:.7rem;padding:1px 8px;" (click)="solarChartOpen=true">📈 24h</button>
    </div>

    <div class="row g-2 g-sm-3 mb-3" *ngIf="solar" [class.section-flash]="solarFlash">

      <div class="col-6 col-xl">
        <div class="card h-100 border-warning">
          <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
            <div class="card-icon fs-2 flex-shrink-0">☀️</div>
            <div class="min-w-0">
              <div class="text-muted small">{{ 'PV_ERTRAG' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-warning text-truncate">{{ formatW(solar.pvYieldW) }}</div>
              <div *ngIf="vs.sunrise" class="text-muted d-none d-xl-block" style="font-size:.65rem;line-height:1.4;">
                🌅 {{ vs.sunrise }} &nbsp;|&nbsp; 🌇 {{ vs.sunset }}
              </div>
            </div>
          </div>
          <div *ngIf="vs.sunrise" class="card-footer d-xl-none text-muted text-center p-1" style="font-size:.62rem;">
            🌅 {{ vs.sunrise }} &nbsp;|&nbsp; 🌇 {{ vs.sunset }}
          </div>
        </div>
      </div>

      <div class="col-6 col-xl">
        <div class="card h-100 border-success">
          <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
            <div class="card-icon fs-2 flex-shrink-0"
                 [class.battery-charging]="solar.batteryDischargeW < 0"
                 [class.battery-discharging]="solar.batteryDischargeW > 0">
              <ng-container *ngIf="solar.batteryDischargeW < 0">⚡</ng-container>
              <ng-container *ngIf="solar.batteryDischargeW > 0">🪫</ng-container>
              <ng-container *ngIf="solar.batteryDischargeW === 0">🔋</ng-container>
            </div>
            <div class="flex-grow-1 min-w-0">
              <div class="text-muted small">{{ 'AKKU' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-truncate"
                   [class.text-success]="solar.batteryDischargeW <= 0"
                   [class.text-danger]="solar.batteryDischargeW > 0">
                {{ formatW(-solar.batteryDischargeW) }}
              </div>
              <div class="progress mt-1" style="height:5px;">
                <div class="progress-bar"
                     [class.bg-success]="solar.batteryDischargeW === 0"
                     [class.progress-bar-charging]="solar.batteryDischargeW < 0"
                     [class.progress-bar-discharging]="solar.batteryDischargeW > 0"
                     [style.width.%]="solar.batteryPercent"></div>
              </div>
              <div class="text-muted mt-1 text-truncate" style="font-size:.72rem;">
                {{ solar.batteryPercent }} %
                <ng-container *ngIf="solar.batteryCapacityWh">
                  &nbsp;·&nbsp;{{ (solar.batteryPercent / 100 * solar.batteryCapacityWh / 1000).toFixed(1) }}&thinsp;/&thinsp;{{ (solar.batteryCapacityWh / 1000).toFixed(0) }}&thinsp;kWh
                </ng-container>
                <ng-container *ngIf="batteryRuntime(solar) as rt">
                  <span class="d-none d-xl-inline">&nbsp;·&nbsp;{{ rt }}</span>
                </ng-container>
              </div>
            </div>
          </div>
          <div *ngIf="batteryRuntime(solar) as rt" class="card-footer d-xl-none text-muted text-center p-1" style="font-size:.62rem;">{{ rt }}</div>
        </div>
      </div>

      <div class="col-6 col-xl">
        <div class="card h-100 border-info">
          <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
            <div class="card-icon fs-2 flex-shrink-0">🔌</div>
            <div class="min-w-0">
              <div class="text-muted small">{{ 'NETZBEZUG' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-truncate"
                   [class.text-danger]="solar.gridConsumptionW > 0"
                   [class.text-success]="solar.gridConsumptionW <= 0">
                {{ formatW(solar.gridConsumptionW) }}
              </div>
              <div class="text-muted small">{{ (solar.gridConsumptionW > 0 ? 'BEZUG' : 'EINSPEISUNG') | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 col-xl">
        <div class="card h-100 border-primary">
          <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
            <div class="card-icon fs-2 flex-shrink-0">🏠</div>
            <div class="min-w-0">
              <div class="text-muted small">{{ 'VERBRAUCH' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-primary text-truncate">{{ formatW(solar.totalConsumptionW) }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Today's autarky summary -->
      <div class="col-6 col-xl" *ngIf="todayStat">
        <div class="card h-100" [class.border-success]="todayStat.autarkiePercent >= 80"
             [class.border-warning]="todayStat.autarkiePercent >= 50 && todayStat.autarkiePercent < 80"
             [class.border-danger]="todayStat.autarkiePercent < 50">
          <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
            <div class="card-icon fs-2 flex-shrink-0">🏡</div>
            <div class="min-w-0 flex-grow-1">
              <div class="d-flex align-items-baseline gap-1">
                <div class="text-muted small">{{ 'HEUTE_AUTARKIE' | translate }}</div>
                <div class="text-muted" style="font-size:.6rem;">{{ 'HEUTE_SEIT' | translate }}</div>
              </div>
              <div class="card-value fs-5 fw-bold text-truncate"
                   [class.text-success]="todayStat.autarkiePercent >= 80"
                   [class.text-warning]="todayStat.autarkiePercent >= 50 && todayStat.autarkiePercent < 80"
                   [class.text-danger]="todayStat.autarkiePercent < 50">
                {{ todayStat.autarkiePercent.toFixed(0) }}&thinsp;%
              </div>
              <div class="text-muted text-truncate d-none d-xl-block" style="font-size:.68rem;line-height:1.5;">
                ⚡&thinsp;{{ formatKwh(todayStat.consumptionKwh) }}
                &nbsp;·&nbsp;🔌&thinsp;{{ formatKwh(todayStat.gridImportKwh) }}
              </div>
            </div>
          </div>
          <div class="card-footer d-xl-none text-muted text-center p-1" style="font-size:.62rem;">
            ⚡&thinsp;{{ formatKwh(todayStat.consumptionKwh) }} &nbsp;·&nbsp; 🔌&thinsp;{{ formatKwh(todayStat.gridImportKwh) }}
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="!solar" class="text-center text-muted py-4">
      <div class="spinner-border spinner-border-sm me-2"></div>{{ 'LADE_SOLARDATEN' | translate }}
    </div>

  </div>

  <!-- ═══ KLIMA ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'klima'">

    <div class="section-divider d-none d-md-flex align-items-center gap-3 my-3">
      <div class="flex-grow-1 border-top"></div>
      <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🌡 Klima</span>
      <div class="flex-grow-1 border-top"></div>
    </div>

    <!-- Thermometer Cards -->
    <div *ngIf="thermometers.length > 0">
      <div class="d-flex align-items-center gap-2 mb-2 mt-md-0 mt-0">
        <span class="badge bg-danger" style="font-size:.7rem;letter-spacing:.05em;"><span [style.opacity]="liveDotOn ? '1' : '0'">●</span> LIVE</span>
        <span class="fw-semibold small text-uppercase">{{ 'THERMOMETER' | translate }}</span>
        <span *ngIf="thermoUpdatedAt" class="text-muted" style="font-size:.65rem;">· {{ 'UPDATED_AGO' | translate:{time: updatedAgo(thermoUpdatedAt)} }}</span>
      </div>
      <div class="row g-2 mb-3" [class.section-flash]="thermoFlash">
        <div class="col-6 col-sm-4 col-lg-3" *ngFor="let t of thermometers">
          <ng-template #thermoPopup>
            <ng-container *ngTemplateOutlet="chartTpl; context:{t: t, full: false}"></ng-container>
          </ng-template>
          <ng-template #thermoTapTpl>
            <ng-container *ngTemplateOutlet="chartTpl; context:{t: t, full: true}"></ng-container>
          </ng-template>
          <app-popup-card popupMaxWidth="90vw" [popupTpl]="thermoPopup" [tapTpl]="thermoTapTpl">
            <ng-template #body>
              <div class="card-body p-2 p-sm-3">
                <div class="d-flex align-items-center thermo-row">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" fill="currentColor" viewBox="0 0 16 16" class="flex-shrink-0 text-muted d-none d-sm-inline">
                    <path d="M9.5 12.5a1.5 1.5 0 1 1-2-1.415V6.5a.5.5 0 0 1 1 0v4.585a1.5 1.5 0 0 1 1 1.415"/>
                    <path d="M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0L9.5 10.486V2.5A1.5 1.5 0 0 0 8 1"/>
                  </svg>
                  <span class="fw-bold text-truncate" style="min-width:0;flex:1;">{{ sensorName(t.name) }}</span>
                  <span class="text-nowrap" style="flex-shrink:0;">{{ t.tempC.toFixed(1) }}°<ng-container *ngIf="t.humidity != null"><span class="d-inline d-sm-none text-muted" style="padding:0 3px;opacity:.4;">|</span><span class="d-none d-sm-inline">&thinsp;
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" viewBox="0 0 16 16" class="text-muted" style="vertical-align:-.05em;">
                      <path fill-rule="evenodd" d="M7.21.8C7.69.295 8 0 8 0c.109.845.468 1.69 1.036 2.572C10.055 4.218 11 5.445 11 7a3 3 0 0 1-6 0c0-1.555.95-2.78 1.964-4.428C7.15 1.486 7.21.8 7.21.8"/>
                    </svg></span>{{ t.humidity.toFixed(0) }}%</ng-container></span>
                </div>
                <ng-container *ngIf="sparklinePoints(t.deviceId).length >= 1">
                  <app-sparkline-chart
                    [points]="sparklinePoints(t.deviceId)"
                    [darkMode]="darkMode"
                    style="display:block;margin-top:4px;">
                  </app-sparkline-chart>
                  <div class="d-flex justify-content-between" style="font-size:.6rem;line-height:1;margin-top:1px;">
                    <span class="text-muted">{{ sparklineMinMax(t.deviceId).min.toFixed(1) }}°</span>
                    <span class="text-muted">24h</span>
                    <span class="text-muted">{{ sparklineMinMax(t.deviceId).max.toFixed(1) }}°</span>
                  </div>
                </ng-container>
              </div>
            </ng-template>
          </app-popup-card>
        </div>
      </div>
    </div>

  </div>

  <!-- ═══ MÜLL ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'muell'">

    <div class="section-divider d-none d-md-flex align-items-center gap-3 my-3">
      <div class="flex-grow-1 border-top"></div>
      <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🗑️ {{ 'MUELLABFUHR' | translate }}</span>
      <div class="flex-grow-1 border-top"></div>
    </div>

    <div *ngIf="nextPickupsByType.length > 0">
      <div class="row g-2">
        <div class="col-6 col-sm-4 col-lg-3 col-xl-2" *ngFor="let p of nextPickupsByType">
          <ng-template #wastePopup>
            <div class="d-flex align-items-center gap-2 mb-2">
              <img [src]="p.icon" alt="" width="24" height="24" style="object-fit:contain;">
              <span class="fw-semibold small">{{ 'MUELL_NAME_' + p.type | translate }}</span>
            </div>
            <div *ngFor="let d of allDatesForType(p.type)"
                 class="d-flex justify-content-between gap-3 py-1 border-bottom"
                 style="font-size:.85rem;">
              <span [class.text-danger]="daysUntil(d) === 0"
                    [class.text-warning]="daysUntil(d) === 1 || daysUntil(d) === 2"
                    [class.fw-bold]="daysUntil(d) <= 2">{{ fmtWasteDate(d) }}</span>
              <span [class.text-success]="daysUntil(d) > 2"
                    [class.text-warning]="daysUntil(d) === 1 || daysUntil(d) === 2"
                    [class.text-danger]="daysUntil(d) === 0">
                {{ wasteRelative(d) }}
              </span>
            </div>
          </ng-template>
          <app-popup-card
              [cardClass]="'h-100' + (daysUntil(p.date) === 0 ? ' border-danger' : (daysUntil(p.date) === 1 || daysUntil(p.date) === 2) ? ' border-warning' : '')"
              popupMaxWidth="320px"
              [popupTpl]="wastePopup">
            <ng-template #body>
              <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
                <img [src]="p.icon" alt="" width="40" height="40" class="flex-shrink-0"
                     style="object-fit:contain;pointer-events:none;">
                <div class="min-w-0">
                  <div class="text-muted small text-truncate">{{ 'MUELL_NAME_' + p.type | translate }}</div>
                  <div class="fw-bold small text-truncate"
                       [class.text-danger]="daysUntil(p.date) === 0"
                       [class.text-warning]="daysUntil(p.date) === 1 || daysUntil(p.date) === 2">
                    {{ fmtWasteDate(p.date) }}
                  </div>
                  <div class="text-truncate d-none d-xl-block" style="font-size:.7rem;"
                       [class.text-success]="daysUntil(p.date) > 2"
                       [class.text-warning]="daysUntil(p.date) === 1 || daysUntil(p.date) === 2"
                       [class.text-danger]="daysUntil(p.date) === 0">
                    {{ wasteRelative(p.date) }}
                  </div>
                </div>
              </div>
              <div class="card-footer d-xl-none text-center p-1" style="font-size:.62rem;"
                   [class.text-success]="daysUntil(p.date) > 2"
                   [class.text-warning]="daysUntil(p.date) === 1 || daysUntil(p.date) === 2"
                   [class.text-danger]="daysUntil(p.date) === 0">
                {{ wasteRelative(p.date) }}
              </div>
            </ng-template>
          </app-popup-card>
        </div>
      </div>
    </div>
    <div *ngIf="nextPickupsByType.length === 0" class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>

  </div>

  <!-- ═══ STATISTIK ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'statistik'">

    <div class="section-divider d-flex align-items-center gap-3 my-3">
      <div class="flex-grow-1 border-top"></div>
      <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">{{ 'STATISTIK_30_TAGE' | translate }}</span>
      <div class="flex-grow-1 border-top"></div>
    </div>
    <div *ngIf="stats.length > 0">
      <div class="d-flex align-items-center gap-2 mb-2">
        <div *ngIf="statsView === 'daily'" class="d-flex flex-wrap gap-1">
          <button class="btn btn-sm" [ngClass]="statsMonthFilter === 'all' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsMonthFilter = 'all'">{{ 'ALLE' | translate }}</button>
          <button *ngFor="let m of statsMonths" class="btn btn-sm" [ngClass]="statsMonthFilter === m ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsMonthFilter = m"><span class="d-none d-sm-inline">{{ fmtMonth(m) }}</span><span class="d-sm-none">{{ fmtMonthShort(m) }}</span></button>
        </div>
        <div class="ms-auto btn-group btn-group-sm">
          <button class="btn" [ngClass]="statsView === 'daily' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsView = 'daily'">Täglich</button>
          <button class="btn" [ngClass]="statsView === 'monthly' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsView = 'monthly'">Monatlich</button>
        </div>
      </div>
      <ag-grid-angular
        *ngIf="statsView === 'daily'"
        [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
        [style.height.px]="statsGridHeight(filteredStats.length)"
        [rowData]="filteredStats"
        [columnDefs]="statsColDefs"
        [gridOptions]="statsGridOptions">
      </ag-grid-angular>
      <ag-grid-angular
        *ngIf="statsView === 'monthly'"
        [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
        [style.height.px]="statsGridHeight(monthlyStats.length)"
        [rowData]="monthlyStats"
        [columnDefs]="monthlyStatsColDefs"
        [gridOptions]="statsGridOptions">
      </ag-grid-angular>
    </div>
    <div *ngIf="stats.length === 0" class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>

  </div>

  <!-- ═══ NETZWERK ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'netzwerk'">

    <div class="section-divider d-flex align-items-center gap-3 my-3">
      <div class="flex-grow-1 border-top"></div>
      <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🌐 Netzwerk</span>
      <div class="flex-grow-1 border-top"></div>
    </div>

    <div *ngIf="unifi === null" class="text-muted small text-center py-2">{{ 'LADE' | translate }}</div>

    <div *ngIf="unifi !== null">

      <!-- Gruppe 1: WAN + Clients -->
      <div class="row g-2 mb-2">

        <!-- WAN Status -->
        <div class="col-6 col-sm-4 col-lg-3 col-xl-2">
          <div class="card h-100" [class.border-success]="unifi.wanUp" [class.border-danger]="!unifi.wanUp">
            <div class="card-body p-2 p-sm-3">
              <div class="text-muted small text-truncate">{{ 'UNIFI_WAN' | translate }}</div>
              <div class="fw-bold fs-5" [class.text-success]="unifi.wanUp" [class.text-danger]="!unifi.wanUp">
                {{ unifi.wanUp ? '● Online' : '● Offline' }}
              </div>
              <div class="text-muted small text-truncate" *ngIf="unifi.wanIp">{{ unifi.wanIp }}</div>
              <div class="text-muted small" *ngIf="unifi.wanLatency >= 0">
                {{ 'UNIFI_LATENZ' | translate }}: {{ unifi.wanLatency }} ms
              </div>
              <div class="text-muted small">{{ fmtUptime(unifi.wanUptime) }}</div>
            </div>
          </div>
        </div>

        <!-- Download -->
        <div class="col-6 col-sm-4 col-lg-3 col-xl-2">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3">
              <div class="text-muted small text-truncate">↓ {{ 'UNIFI_DOWNLOAD' | translate }}</div>
              <div class="fw-bold fs-5 text-truncate text-info">{{ fmtBps(unifi.wanRxBps) }}</div>
            </div>
          </div>
        </div>

        <!-- Upload -->
        <div class="col-6 col-sm-4 col-lg-3 col-xl-2">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3">
              <div class="text-muted small text-truncate">↑ {{ 'UNIFI_UPLOAD' | translate }}</div>
              <div class="fw-bold fs-5 text-truncate text-info">{{ fmtBps(unifi.wanTxBps) }}</div>
            </div>
          </div>
        </div>

        <!-- Clients gesamt -->
        <div class="col-6 col-sm-4 col-lg-3 col-xl-2">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3">
              <div class="text-muted small text-truncate">{{ 'UNIFI_CLIENTS' | translate }}</div>
              <div class="fw-bold fs-5">{{ unifi.totalClients }}</div>
              <div class="text-muted small">
                📶 {{ unifi.wlanClients }} &nbsp; 🔌 {{ unifi.lanClients }}
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Gruppe 2: Geräte -->
      <div class="section-divider d-flex align-items-center gap-3 my-2">
        <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
        <span class="small text-muted px-1">{{ 'UNIFI_GERAETE' | translate }}</span>
        <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
      </div>

      <div class="row g-2 mb-2">
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3" *ngFor="let dev of unifi.devices">
          <div class="card h-100" [class.border-success]="dev.online" [class.border-secondary]="!dev.online" style="opacity: dev.online ? 1 : 0.6">
            <div class="card-body p-2 p-sm-3">
              <div class="d-flex align-items-start gap-2">
                <span style="font-size:1.4rem;line-height:1;">{{ deviceIcon(dev.type) }}</span>
                <div class="min-w-0 flex-grow-1">
                  <div class="fw-semibold small text-truncate">{{ dev.name }}</div>
                  <div class="text-muted" style="font-size:.7rem;">{{ deviceLabel(dev.type) }} · {{ dev.model }}</div>
                  <div class="text-muted" style="font-size:.7rem;">
                    <span [class.text-success]="dev.online" [class.text-secondary]="!dev.online">
                      {{ dev.online ? '● Online' : '○ Offline' }}
                    </span>
                    <span *ngIf="dev.online"> · {{ fmtUptime(dev.uptime) }}</span>
                  </div>
                  <div *ngIf="dev.numClients >= 0" class="text-muted" style="font-size:.7rem;">
                    📶 {{ dev.numClients }} {{ 'UNIFI_CLIENTS' | translate }}
                  </div>
                  <div *ngIf="dev.online && (dev.rxBps > 0 || dev.txBps > 0)" class="text-muted" style="font-size:.7rem;">
                    ↓ {{ fmtBps(dev.rxBps) }} · ↑ {{ fmtBps(dev.txBps) }}
                  </div>
                  <div class="text-muted" style="font-size:.7rem;">{{ dev.ip }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="unifi.devices.length === 0" class="col-12">
          <div class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>
        </div>
      </div>

      <!-- Gruppe 3: Top-Clients -->
      <div *ngIf="unifi.topClients.length > 0">
        <div class="section-divider d-flex align-items-center gap-3 my-2">
          <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
          <span class="small text-muted px-1">{{ 'UNIFI_TOP_CLIENTS' | translate }}</span>
          <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
        </div>

        <div class="table-responsive">
          <table class="table table-sm table-hover mb-0" style="font-size:.8rem;">
            <thead>
              <tr class="text-muted">
                <th>{{ 'UNIFI_HOSTNAME' | translate }}</th>
                <th class="d-none d-sm-table-cell">IP</th>
                <th>Typ</th>
                <th class="text-end">↓</th>
                <th class="text-end">↑</th>
                <th class="text-end d-none d-md-table-cell">{{ 'UNIFI_GESAMT' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cl of unifi.topClients">
                <td class="text-truncate" style="max-width:120px;">{{ cl.hostname }}</td>
                <td class="text-muted d-none d-sm-table-cell text-truncate" style="max-width:110px;">{{ cl.ip }}</td>
                <td>
                  <span *ngIf="cl.isWifi">
                    📶 <span [class]="signalClass(cl.signal)" style="font-size:.75rem;">{{ cl.signal }} dBm</span>
                  </span>
                  <span *ngIf="!cl.isWifi" class="text-muted">🔌 LAN</span>
                </td>
                <td class="text-end text-info text-nowrap">{{ fmtBps(cl.rxBps) }}</td>
                <td class="text-end text-info text-nowrap">{{ fmtBps(cl.txBps) }}</td>
                <td class="text-end text-muted text-nowrap d-none d-md-table-cell">
                  {{ fmtBytes(cl.rxBytes + cl.txBytes) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

  </div>

</div>

<!-- Chart template — full=false for hover popover, full=true for click overlay -->
<ng-template #chartTpl let-t="t" let-full="full">
  <div class="fw-semibold small text-center mb-1">{{ sensorName(t.name) }}</div>
  <app-sparkline-chart
    [points]="sparklinePoints(t.deviceId)"
    [darkMode]="darkMode"
    [expanded]="true"
    style="display:block;">
  </app-sparkline-chart>
  <div class="text-muted text-center mt-1" style="font-size:.6rem;">
    {{ sparklinePoints(t.deviceId).length }} {{ 'MESSPUNKTE' | translate }}
  </div>
</ng-template>

<!-- Footer -->
<footer class="fixed-bottom bg-body-tertiary border-top d-flex align-items-center px-3 flex-nowrap gap-2"
        style="height:48px;z-index:1030;">
  <span class="text-muted small me-auto text-nowrap overflow-hidden" style="min-width:0;">
    © {{ currentYear }}
    <span class="d-none d-sm-inline">blonkel.com</span>
    &nbsp;|&nbsp;<code style="cursor:pointer;" (click)="openChangelog()" title="Changelog">{{ shortHash(frontendCommit) }}</code>
    <span class="d-none d-sm-inline">&nbsp;|&nbsp;<code style="cursor:pointer;" (click)="openChangelog()" title="Changelog">{{ shortHash(vs.backendCommit) || '…' }}</code></span>
  </span>
  <span class="text-muted small text-nowrap flex-shrink-0" [title]="'OFFENE_WEBSOCKET' | translate">
    {{ vs.connectedClients }} 👥
  </span>
  <!-- Dark mode toggle -->
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0 px-2 ms-1" (click)="toggleDarkMode()"
          [title]="(darkMode ? 'LIGHT_MODE' : 'DARK_MODE') | translate" style="line-height:1;">
    <svg *ngIf="darkMode" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"/>
    </svg>
    <svg *ngIf="!darkMode" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/>
    </svg>
  </button>
  <!-- Language switcher -->
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0 px-2" (click)="openLangPicker()" [title]="'SPRACHE' | translate">
    {{ currentLangFlag }}
  </button>
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0" (click)="toggleLogs()">
    🗒 {{ 'LOGS' | translate }}
  </button>
</footer>

<!-- Log Overlay -->
<div *ngIf="logsOpen"
     style="position:fixed;inset:0;z-index:1050;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="logsOpen = false">

  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:calc(100vw - 32px);height:calc(100vh - 32px);border-radius:8px;"
       (click)="$event.stopPropagation()">

    <!-- Overlay Header -->
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">{{ 'LOGS' | translate }}</span>
      <div class="btn-group btn-group-sm" role="group">
        <button type="button" class="btn"
                [class.btn-secondary]="logLevel === 'all'"
                [class.btn-outline-secondary]="logLevel !== 'all'"
                (click)="setLogLevel('all')">{{ 'ALLE' | translate }}</button>
        <button type="button" class="btn"
                [class.btn-secondary]="logLevel === 'low'"
                [class.btn-outline-secondary]="logLevel !== 'low'"
                (click)="setLogLevel('low')">Low</button>
        <button type="button" class="btn"
                [class.btn-warning]="logLevel === 'medium'"
                [class.btn-outline-warning]="logLevel !== 'medium'"
                (click)="setLogLevel('medium')">Medium</button>
        <button type="button" class="btn"
                [class.btn-danger]="logLevel === 'high'"
                [class.btn-outline-danger]="logLevel !== 'high'"
                (click)="setLogLevel('high')">High</button>
      </div>
      <button class="btn btn-sm btn-outline-secondary" (click)="fetchLogs()" [title]="'AKTUALISIEREN' | translate">↻</button>
      <button class="btn btn-sm btn-outline-secondary" (click)="logsOpen = false">✕</button>
    </div>

    <!-- Password prompt -->
    <div *ngIf="!logAuthenticated"
         class="flex-grow-1 d-flex align-items-center justify-content-center p-4">
      <div style="max-width:320px;width:100%;">
        <div *ngIf="logAuthError" class="alert alert-danger py-2 small mb-3">{{ 'FALSCHES_PASSWORT' | translate }}</div>
        <label class="form-label fw-semibold">{{ 'PASSWORT' | translate }}</label>
        <div class="input-group">
          <input type="password" class="form-control" [(ngModel)]="logPassword"
                 [placeholder]="'LOGS_PASSWORT' | translate"
                 (keydown.enter)="submitLogPassword()">
          <button class="btn btn-primary" (click)="submitLogPassword()">{{ 'OEFFNEN' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Grid -->
    <div *ngIf="logAuthenticated" class="flex-grow-1 overflow-hidden p-2">
      <div *ngIf="copiedCell" class="text-muted small mb-1">{{ 'KOPIERT' | translate }}</div>
      <div *ngIf="logs.length === 0" class="text-muted small text-center py-3">{{ 'KEINE_EINTRAEGE' | translate }}</div>
      <ag-grid-angular
        *ngIf="logs.length > 0"
        [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
        style="height:100%;"
        [rowData]="logs"
        [columnDefs]="colDefs"
        [gridOptions]="gridOptions"
        [tooltipShowDelay]="200">
      </ag-grid-angular>
    </div>

  </div>
</div>

<!-- Language Picker Overlay -->
<div *ngIf="langPickerOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="langPickerOpen = false">

  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:min(94vw,560px);max-height:80vh;border-radius:12px;overflow:hidden;"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">🌐 {{ 'SPRACHE' | translate }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="langPickerOpen = false">✕</button>
    </div>

    <!-- Search -->
    <div class="px-3 py-2 border-bottom flex-shrink-0">
      <input class="form-control form-control-sm" type="search"
             [placeholder]="'SUCHEN' | translate" [(ngModel)]="langSearch" autofocus>
    </div>

    <!-- Language grid -->
    <div class="overflow-auto p-2" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:6px;">
      <button *ngFor="let l of filteredLanguages"
              class="btn btn-sm text-start d-flex align-items-center gap-2 px-2 py-2"
              [class.btn-primary]="translate.currentLang === l.code"
              [class.btn-secondary]="translate.currentLang !== l.code && supportedLangs.has(l.code)"
              [class.btn-outline-secondary]="!supportedLangs.has(l.code)"
              [style.opacity]="supportedLangs.has(l.code) ? '1' : '0.4'"
              [disabled]="!supportedLangs.has(l.code)"
              (click)="selectLang(l.code)">
        <span style="font-size:1.3rem;line-height:1;">{{ l.flag }}</span>
        <span class="min-w-0">
          <div class="fw-semibold small text-truncate" style="line-height:1.2;">{{ l.native }}</div>
          <div class="text-muted" style="font-size:.7rem;line-height:1.2;">{{ l.name }}</div>
        </span>
      </button>
    </div>

  </div>
</div>

<!-- 24h Solar Chart Overlay -->
<div *ngIf="solarChartOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.6);"
     (click)="solarChartOpen=false">
  <div class="bg-body shadow-lg"
       style="width:min(92vw,1600px);max-height:92vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold">📈 24h</span>
      <div class="d-flex flex-wrap gap-2 ms-auto" style="font-size:.75rem;">
        <span><span style="color:#f59e0b;">■</span> ☀️ {{ 'CHART_ERTRAG' | translate }}</span>
        <span><span style="color:#22c55e;">■</span> 🔋 {{ 'AKKU' | translate }}</span>
        <span><span style="color:#ef4444;">■</span> 🔌 {{ 'CHART_NETZ' | translate }}</span>
        <span><span style="color:#3b82f6;">■</span> ⚡ {{ 'VERBRAUCH' | translate }}</span>
      </div>
      <button class="btn btn-sm btn-outline-secondary ms-2" (click)="solarChartOpen=false">✕</button>
    </div>
    <div class="p-2 p-sm-3">
      <app-solar-chart
        [history]="solarHistory"
        [darkMode]="darkMode"
        [labelPv]="'CHART_ERTRAG' | translate"
        [labelBattery]="'AKKU' | translate"
        [labelGrid]="'CHART_NETZ' | translate"
        [labelTotal]="'VERBRAUCH' | translate">
      </app-solar-chart>
      <div class="text-muted text-center mt-1" style="font-size:.65rem;">{{ solarHistory.length }} {{ 'MESSPUNKTE' | translate }}</div>
    </div>
  </div>
</div>

<!-- Disconnect overlay (hidden when version update overlay takes over) -->
<div *ngIf="!vs.connected && !newVersionVisible"
     style="position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:1060;display:flex;align-items:center;justify-content:center;">
  <div class="card text-center shadow-lg p-4" style="max-width:340px;">
    <div class="spinner-border text-danger mx-auto mb-3" role="status"></div>
    <h5 class="card-title">{{ 'VERBINDUNG_UNTERBROCHEN' | translate }}</h5>
    <p class="card-text text-muted small">{{ 'VERBINDUNG_VERLOREN' | translate }}</p>
  </div>
</div>

<!-- Changelog Overlay -->
<div *ngIf="changelogOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="changelogOpen = false">
  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:min(96vw,640px);max-height:80vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">{{ 'CHANGELOG' | translate }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="changelogOpen = false">✕</button>
    </div>
    <div class="overflow-auto p-3">
      <div *ngIf="changelog.length === 0" class="text-muted small text-center py-3">
        <div class="spinner-border spinner-border-sm me-2"></div>{{ 'LADE' | translate }}
      </div>
      <div *ngFor="let c of changelog" class="d-flex gap-3 py-2 border-bottom">
        <div class="flex-shrink-0 text-muted small" style="width:80px;padding-top:2px;">
          <div>{{ c.date }}</div>
          <code style="font-size:.7rem;">{{ c.hash | slice:0:7 }}</code>
        </div>
        <div class="min-w-0">
          <div class="small fw-semibold text-break">{{ c.subject }}</div>
          <div class="text-muted" style="font-size:.7rem;">{{ c.author }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Version update overlay -->
<div *ngIf="newVersionVisible"
     style="position:fixed;inset:0;background:rgba(0,0,0,0.65);z-index:1070;display:flex;align-items:center;justify-content:center;">
  <div class="card text-center shadow-lg p-4" style="max-width:360px;">
    <div class="fs-1 mb-2">🚀</div>
    <h5 class="card-title">{{ 'NEUE_VERSION' | translate }}</h5>
    <p class="card-text text-muted small mb-3">{{ 'NEUE_VERSION_HINWEIS' | translate }}</p>
    <button class="btn btn-primary" (click)="location.reload()">{{ 'NEUE_VERSION_LADEN' | translate }} ({{ versionCountdown }})</button>
  </div>
</div>
